import { type IconProps } from './types'

export function TextBgColorIcon({
  width = '24',
  height = '24',
  fillColor = 'currentColor',
  secondaryColor = '#CECECE',
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.554688" y="0.5" width="20" height="20" rx="5" fill={secondaryColor} />
      <path
        d="M6.13026 16.8334C6.56454 16.8334 6.95359 16.5619 7.0893 16.1548L8.00311 13.5943H13.115L14.0107 16.1457C14.1555 16.5619 14.5445 16.8334 14.9788 16.8334C15.6936 16.8334 16.1822 16.1186 15.9288 15.4581L12.0836 5.22526C11.8483 4.59193 11.2331 4.16669 10.5545 4.16669C9.87597 4.16669 9.26073 4.59193 9.02549 5.22526L5.18026 15.4581C4.92692 16.1186 5.42454 16.8334 6.13026 16.8334ZM10.5003 6.51907H10.6088L12.4455 11.7576H8.66359L10.5003 6.51907Z"
        fill={fillColor}
      />
    </svg>
  )
}
